import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

import PageWrapper from '../components/pageWrapperHOC';
import Feedback from '../components/srp/Feedback';
import CompanyInformation from '../components/success-stories/CompanyInformation';
import ProjectSummary from '../components/success-stories/ProjectSummary';
import { SuccessStoriesContextProvider } from '../common/context/success-stories/context';
import SecondaryNavigation from '../components/srp/SecondaryNavigation';
import StoryBanner from '../components/success-stories/StoryBanner';
import MoreSuccessStories from '../components/success-stories/MoreSuccessStories';
import TermsOfUse from '../components/srp/TermsOfUse';

const SuccessStories = ({ store }) => {
  const [goBack, setGoBack] = useState(false);
  const params = useParams(); // replaces match.params

  const detailBack = () => {
    setGoBack(true);
  };

  return (
    <SuccessStoriesContextProvider goBack={goBack} setGoBack={setGoBack} store={store} params={params}>
      <PageWrapper params={params}>
        <RootElement>
          <SecondaryNavigation onBack={detailBack} backBtnText="Back to Profile" />
          <StoryBanner />
          <CompanyInformation />
          <ProjectSummary />
          <MoreSuccessStories />
          <Feedback />
          <TermsOfUse showTerms={false} />
        </RootElement>
      </PageWrapper>
    </SuccessStoriesContextProvider>
  );
};

const RootElement = styled.div``;

SuccessStories.propTypes = {
  store: PropTypes.shape({}),
};

SuccessStories.defaultProps = {
  store: {},
};

export default SuccessStories;
